import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { AddCardModalText } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const Wrapper = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .continueButton {
    margin-top: 50px;
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: -15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
    }
  }
  .choose {
    font-size: ${({ theme }) => theme.fontSize.x7};
    line-height: 14px;
    font-weight: 500;
  }
  .wallet {
    font-size: 24px;
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 4px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.8;
  }
  .destination,
  .amount {
    margin-top: 20px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 0px -47px;
  }
  .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  }
  .confirm {
    margin: 10px 0px;
  }
  .note {
    margin-top: 15px;
  }
  .top {
    margin-top: 120px;
  }
  .tops {
    margin-top: 10px;
  }
  .topss {
    margin-top: 50px;
  }
`
const TransferEmergencySavings = () => {
  let location = useLocation()
  const options = [{ value: 'General Savings', label: 'General Savings' }]
  return (
    <Wrapper>
      <AddCardModalText className="wallet">
        Transfer From Emergency
      </AddCardModalText>
      <p className="choose">
        You can send funds from your Emergency savings to another user on F&K
        user or transfer to your General savings instead.
      </p>
      <div className="destination">
        <h4>Tap here to choose source</h4>
        <Select options={options} />
      </div>
      <div className="amount">
        <h4>Enter an amount</h4>
        <QuicksaveInput type="number" name="Amount" placeholder="e.g 3,000" />
      </div>
      <p className="note">
        Note that in Emergency tranfers, you get your money tranferred
        immediately and completely free.
      </p>
      <div className="top">
        <div className="line"></div>
        <Link
          to={`/transfer-emergency-user`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="confirm">Withdraw</ModalButton>
        </Link>
        <Link to={`/quicksave-one`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </Wrapper>
  )
}

const TransferEmergencyUsers = () => {
  let location = useLocation()
  const options = [{ value: 'General Savings', label: 'General Savings' }]
  return (
    <Wrapper>
      <AddCardModalText className="wallet">
        Transfer From Emergency
      </AddCardModalText>
      <p className="choose">
        You can send funds from your Emergency savings to another user on F&K
        user or transfer to your General savings instead.
      </p>
      <div className="destination">
        <h4>Tap here to choose source</h4>
        <Select options={options} />
      </div>
      <QuicksaveInput
        className="tops"
        type="number"
        name="Amount"
        placeholder="Enter member ID or phone no."
      />
      <div className="amount">
        <h4>Enter an amount</h4>
        <QuicksaveInput type="number" name="Amount" placeholder="e.g 3,000" />
      </div>
      <p className="note">
        Note that in Emergency tranfers, you get your money tranferred
        immediately and completely free.
      </p>
      <div className="topss">
        <div className="line"></div>
        <Link to={`/big/confirmation`} state={{ backgroundLocation: location }}>
          <ModalButton className="confirm">Transfer</ModalButton>
        </Link>
        <Link to={`/quicksave-one`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </Wrapper>
  )
}
export { TransferEmergencySavings, TransferEmergencyUsers }
